import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", {
  fill: "currentColor",
  "fill-rule": "nonzero"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M12.3 3.25c5.55 0 10.05 4.5 10.05 10.05 0 2.682-.9 5.258-2.524 7.018l-.222.242H4.996l-.222-.242C3.15 18.558 2.25 15.982 2.25 13.3c0-5.55 4.5-10.05 10.05-10.05m0 1.5a8.55 8.55 0 0 0-8.55 8.55c0 2.102.633 4.112 1.756 5.563l.159.197h13.269l.16-.197c1.064-1.375 1.688-3.251 1.75-5.232l.006-.331a8.55 8.55 0 0 0-8.55-8.55" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M12.3 12.085a2.61 2.61 0 1 1 0 5.22 2.61 2.61 0 0 1 0-5.22m0 1.5a1.11 1.11 0 1 0 0 2.22 1.11 1.11 0 0 0 0-2.22" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M12.3 9.295a.75.75 0 0 1 .75.75v2.79a.75.75 0 1 1-1.5 0v-2.79a.75.75 0 0 1 .75-.75M12.3 5.575a.75.75 0 0 1 .75.75v.93a.75.75 0 1 1-1.5 0v-.93a.75.75 0 0 1 .75-.75M6.255 13.015a.75.75 0 0 1 0 1.5h-.93a.75.75 0 1 1 0-1.5zM6.655 8.585a.75.75 0 0 1 1.06 0l.658.657a.75.75 0 0 1-1.06 1.06l-.658-.657a.75.75 0 0 1 0-1.06M19.275 13.015a.75.75 0 0 1 0 1.5h-.93a.75.75 0 1 1 0-1.5zM17.077 8.585a.75.75 0 1 1 1.06 1.06l-.657.658a.75.75 0 1 1-1.06-1.06z" })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }